import $foreign from "./foreign.cjs";
var foldlArray = $foreign.foldlArray;
var foldrArray = $foreign.foldrArray;
export { foldlArray, foldrArray };
